<template>
    <section class="overlay-view" :class="{ 'overlay-view--przerwa-z-plansza': isBreakWithPlaceholder }">
        <img v-if="logo" :src="logo" class="logo position-fixed top-0" />

        <div id="top" class="overlay-line-height position-fixed bottom-0 end-0 lh-1">
            <div id="top_inner" class="d-flex align-items-center justify-content-end text-end">
                <!--
                    Napis, ktory sie nie miesci, jedzie w petli w jedna strone - druga kopia
                    wjezdza za pierwsza, wiec pasek nigdy nie jest pusty i nie trzeba czytac
                    od tylu. Kopia pojawia sie dopiero, gdy petla jest wlaczona.
                -->
                <h1 ref="clientNameHeader" class="d-inline-block m-0" :title="headerClientName">
                    <span class="overlay-header-text">
                        <span class="overlay-header-text__copy">{{ headerClientName }}</span>
                        <span class="overlay-header-text__copy" aria-hidden="true" v-if="headerLoop.client">{{ headerClientName }}</span>
                    </span>
                </h1>
                <h1 ref="sessionNameHeader" class="posiedzenie d-inline-block m-0" :title="headerSessionName">
                    <span class="overlay-header-text">
                        <span class="overlay-header-text__copy">{{ headerSessionName }}</span>
                        <span class="overlay-header-text__copy" aria-hidden="true" v-if="headerLoop.session">{{ headerSessionName }}</span>
                    </span>
                </h1>
            </div>
        </div>

        <Transition name="voting-info-expand">
            <div id="komunikat" class="overlay-line-height position-fixed start-0 w-100 lh-1" v-if="showVotingStartedInfo">
                <div id="komunikat_inner" class="d-flex align-items-center overflow-hidden text-nowrap text-white">
                    <span>{{ $t('com.file.info-modal.voting-info') }}: <strong>{{ votingStartedName }}</strong></span>
                </div>
            </div>
        </Transition>

        <div id="punkt" class="overlay-line-height position-fixed lh-1" v-if="activePointName">
            <div id="punkt_inner" class="d-flex align-items-center overflow-hidden text-nowrap text-white">
                <marquee class="d-block w-100" behavior="scroll" scrollamount="10" direction="left">
                    <b class="punkt-label fw-bold text-white">{{ $t('com.file.overlay.current-topic') }}: </b>{{ activePointName }}
                </marquee>
            </div>
        </div>

        <Transition name="speaker-slide">
            <div id="bottom" class="overlay-line-height position-fixed bottom-0 lh-1" v-if="showSpeeker">
                <div id="inner" class="d-flex align-items-center text-white">
                    <div class="mowca d-flex w-100 flex-row align-items-center">
                        <div class="mowca-dane d-flex flex-column text-white">
                            <h1>{{ speeker.name }} {{ speeker.surname }}</h1>
                            <p class="stan overflow-hidden text-nowrap" v-if="speeker.role">{{ speeker.role }}</p>
                        </div>
                        <div class="mowca-czas d-flex align-items-center ms-auto text-nowrap">
                            <span class="mowca-czas__separator" aria-hidden="true"></span>
                            <span class="mowca-czas__plus" v-if="isSpeechOvertime">+</span>
                            <span class="mowca-czas__wartosc">{{ speechTimeLabel }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>

        <Transition>
            <PublicPlaceholderView v-if="$store.state.public.publicPlaceholderViewModalStatus"
                                   :placeholder="placeholderData" />
        </Transition>

        <div id="przerwa" class="overlay-line-height position-fixed lh-1"
             :class="{ 'overflow-hidden': isBreakWithPlaceholder }"
             v-if="showBreak">
            <div class="przerwa-inner d-flex h-100 w-100 flex-column justify-content-center"
                 :class="{ 'align-items-start text-start': isBreakWithPlaceholder }">
                <p class="przerwa-logo m-0"><img :src="$appConfig.logo.pathBlack" :alt="$appConfig.logo.alt" /></p>
                <h1 class="m-0">{{ $t('com.file.info-modal.break-info') }}</h1>
                <div class="przerwa-info" :class="{ 'd-flex w-100 flex-column': isBreakWithPlaceholder }">
                    <p class="przerwa-koniec" :class="{ 'd-flex w-100 align-items-center m-0': isBreakWithPlaceholder }">
                        <svg class="przerwa-koniec__ikona"
                             :class="{ 'd-block flex-shrink-0': isBreakWithPlaceholder }"
                             viewBox="0 0 24 24"
                             aria-hidden="true">
                            <circle cx="12" cy="12" r="9" />
                            <path d="M12 6.8V12.4l3.6 2.1" />
                        </svg>
                        <span class="przerwa-koniec__etykieta" :class="{ 'd-inline': isBreakWithPlaceholder }">
                            {{ $t('com.file.info-modal.end-break-info') }}:
                        </span>
                        <span class="przerwa-koniec__godzina"
                              :class="{ 'd-inline fw-bold ms-auto': isBreakWithPlaceholder }">
                            {{ breakEndLabel }}
                        </span>
                    </p>
                    <p class="przerwa-odliczanie"
                       :class="{
                           'przerwa-odliczanie--po-czasie': isBreakOvertime,
                           'position-relative m-0 w-100 overflow-hidden': isBreakWithPlaceholder
                       }">
                        <span class="przerwa-odliczanie__etykieta"
                              :class="{ 'position-relative d-block text-uppercase': isBreakWithPlaceholder }">
                            {{ $t('com.file.overlay.break-remaining') }}
                        </span>
                        <span class="przerwa-odliczanie__czas"
                              :class="{ 'position-relative d-block fw-bold': isBreakWithPlaceholder }">
                            <span v-if="isBreakOvertime">+</span>{{ breakCountdown }}
                        </span>
                    </p>
                </div>
            </div>
        </div>

        <QuorumResultModal v-if="showQuorumResultModal" :quorumresult="quorumresult" :isPublicView="true" />

        <InteractiveVotingPublicModal v-if="$store.state.public.interactiveVotingModalStatus"
                                      :votingPossibleAnswers="votingPossibleAnswers"
                                      :basicData="dataForVoting"
                                      :hiddenResults="hiddenResults" />

        <Transition>
            <InteractiveVotingResults v-if="$store.state.votingStore.isShowInteractiveVotingResultsModal" />
        </Transition>

        <InteractiveAttachmentModal v-if="showAttachmentViewer"
                                    :fileData="attachmentData.fileData"
                                    :page="attachmentData.page"
                                    :scale="attachmentData.scale"
                                    :scrool="attachmentData.scrool" />

        <div id="ldown" class="overlay-line-height position-fixed bottom-0 lh-1">
            <div id="lback" class="d-flex align-items-center justify-content-center bg-white">
                <img class="d-block" :src="overlayLogo" :alt="$appConfig.logo.alt" />
            </div>
            <div id="clock" class="d-flex align-items-center justify-content-center text-center text-white">
                {{ clockHours }}<dot>:</dot>{{ clockMinutes }}
            </div>
        </div>
    </section>
</template>

<script charset="utf-8">
    import moment from "moment";
    import PublicService from "../services/public.service";
    import esesjaInteractivePublicService from "../services/esesja.interactive.public.service";
    import signalrSocketAction from "../services/esesja.signalr.action";
    import overlayVmix from "../helpers/overlay.vmix.helper";
    import i18nService from "../services/i18n.service";
    import toolsService from "../services/tools.service";
    import i18n from "../helpers/i18n.helper";
    import { getLeadZero, timeUnitsBetween } from "../helpers/utils";
    import { getPublicSessionName } from "../helpers/session.helper";
    import { formatDateToDisplay } from "../helpers/i18n.utils";
    import overlayLogo from "@/assets/imgs/overlay-logo.png";
    import { captureServerReference, emptyServerReference, speechTime as calculateSpeechTime } from "../helpers/speech.time.helper";
    import QuorumResultModal from "../components/Panel/Interactive/Modals/QuorumResultModal.vue";
    import InteractiveVotingResults from "../components/Panel/Content/SessionPoints/Modals/InteractiveVotingResults.vue";
    import InteractiveVotingPublicModal from "../views/Modals/InteractiveVotingPublicModal.vue";
    import InteractiveAttachmentModal from "./Modals/InteractiveAttachmentModal.vue";
    import PublicPlaceholderView from "../views/Modals/PublicPlaceholderView.vue";

    // Jak szybko nakladka zauwaza uruchomienie/zakonczenie posiedzenia. Kazde odpytanie
    // sciaga pelny stan sesji, wiec skracanie tego w nieskonczonosc kosztuje - przy dalszym
    // zejscu warto najpierw dolozyc lekki endpoint zwracajacy samo {isLive, sessionId}.
    const SESSION_POLL_INTERVAL_MS = 10000;
    const VOTING_INFO_VISIBLE_MS = 5000;
    const TICK_INTERVAL_MS = 1000;
    // zegar idzie na wizji - zegar maszyny z vMixem potrafi odbiegac od serwera,
    // wiec resynchronizujemy sie co kilka minut zamiast ufac lokalnemu czasowi
    const TIME_SYNC_INTERVAL_MS = 300000;

    export default {
        name: "OverlayView",
        components: {
            QuorumResultModal,
            InteractiveVotingResults,
            InteractiveVotingPublicModal,
            InteractiveAttachmentModal,
            PublicPlaceholderView
        },
        data() {
            return {
                code: "",
                sessionId: 0,
                // Do ktorej grupy SignalR jestesmy FAKTYCZNIE zapisani. Rozdzielone od
                // sessionId, bo nieudany start()/joinRoom() nie moze wygladac jak sukces -
                // inaczej petla porownuje sessionId, nie widzi zmiany i nigdy nie ponawia.
                joinedSessionId: 0,
                clientName: "",
                sessionName: "",
                logo: "",

                activePointName: "",
                agendaItems: [],

                speeker: {},
                showSpeeker: false,
                isDummySpeechActive: false,
                speechReference: emptyServerReference(),
                speechTimeLabel: "00:00:00",
                isSpeechOvertime: false,

                showVotingStartedInfo: false,
                votingStartedName: "",
                votingInfoTimer: null,

                showBreak: false,
                breakEndTime: null,
                breakEndLabel: "",
                breakCountdown: "00:00:00",
                isBreakOvertime: false,

                placeholderData: {},

                quorumresult: [],
                showQuorumResultModal: false,
                quorumIsRunning: false,

                hiddenResults: false,
                votingPossibleAnswers: [],
                dataForVoting: {},

                showAttachmentViewer: false,
                attachmentData: {
                    fileData: {},
                    page: 1,
                    scale: 0,
                    scrool: 0
                },

                overlayLogo,
                clockHours: "00",
                clockMinutes: "00",
                currentDateLabel: "",
                currentDayKey: "",
                serverOffsetMs: 0,
                tickTimer: null,
                pollTimer: null,
                timeSyncTimer: null,
                recoveryPromise: null,
                headerResizeObserver: null,
                headerAnimations: [],
                headerLoop: { client: false, session: false },
                headerScrollToken: 0
            };
        },
        computed: {
            getLangCode() {
                return this.$route.query.lang;
            },
            /** ?o= nadpisuje nazwe klienta, tak jak w starej nakladce */
            headerClientName() {
                return this.$route.query.o || this.clientName;
            },
            /** ?p= nadpisuje nazwe posiedzenia */
            headerSessionName() {
                return this.$route.query.p || this.sessionName;
            },
            /**
             * Przerwa i plansza jednoczesnie - wtedy zamiast nakladania sie na siebie
             * dzielimy ekran: informacja o przerwie w lewej kolumnie, plansza w reszcie.
             */
            isBreakWithPlaceholder() {
                return this.showBreak && this.$store.state.public.publicPlaceholderViewModalStatus;
            }
        },
        watch: {
            headerClientName() {
                this.$nextTick(this.refreshHeaderScrolling);
            },
            headerSessionName() {
                this.$nextTick(this.refreshHeaderScrolling);
            }
        },
        async created() {
            try {
                const languageObj = await i18nService.setLocaleByLanguageCodeForOw(this.getLangCode);
                const messageResult = await i18nService.geti18nMessages(languageObj.id);
                if (messageResult.status !== 200) {
                    throw await Promise.reject(messageResult);
                }
                i18n.global.setLocaleMessage(languageObj.code, messageResult.data);
                this.$i18n.locale = languageObj.code;
            }
            catch (e) {
                console.log(e);
            }
        },
        async mounted() {
            document.body.classList.add("overlay-mode");
            this.ensureOverlayFont();
            this.observeHeaderOverflow();
            overlayVmix.configureFromQuery(this.$route.query);

            this.code = this.$route.params.code;

            await this.syncServerTime();
            this.tick();
            this.tickTimer = setInterval(this.tick, TICK_INTERVAL_MS);
            this.timeSyncTimer = setInterval(this.syncServerTime, TIME_SYNC_INTERVAL_MS);

            // rejestracja przed polaczeniem - inaczej zdarzenia miedzy joinRoom
            // a subskrypcja przepadaja
            this.registerInteractiveEvents();
            document.addEventListener("visibilitychange", this.handleConnectionResume);
            window.addEventListener("online", this.handleConnectionResume);
            window.addEventListener("pageshow", this.handleConnectionResume);

            await this.loadSession();

            this.pollTimer = setInterval(this.pollForSessionChange, SESSION_POLL_INTERVAL_MS);
        },
        unmounted() {
            this.headerResizeObserver?.disconnect();
            this.stopHeaderScrolling();
            document.body.classList.remove("overlay-mode");
            this.unregisterInteractiveEvents();
            document.removeEventListener("visibilitychange", this.handleConnectionResume);
            window.removeEventListener("online", this.handleConnectionResume);
            window.removeEventListener("pageshow", this.handleConnectionResume);
            clearInterval(this.tickTimer);
            clearInterval(this.pollTimer);
            clearInterval(this.timeSyncTimer);
            clearTimeout(this.votingInfoTimer);
            esesjaInteractivePublicService.stop().catch(() => { });
        },
        methods: {
            headerTargets() {
                return [
                    { header: this.$refs.clientNameHeader, key: "client" },
                    { header: this.$refs.sessionNameHeader, key: "session" }
                ];
            },
            observeHeaderOverflow() {
                this.headerResizeObserver = new ResizeObserver(this.refreshHeaderScrolling);
                for (const { header } of this.headerTargets()) {
                    this.headerResizeObserver.observe(header);
                    // Mierzymy pierwsza kopie, nie cala sciezke: po wlaczeniu petli sciezka
                    // robi sie dwa razy szersza i sama wybudzalaby obserwatora w kolko.
                    // Szerokosc kopii zmienia sie tylko przy zmianie tekstu i po doladowaniu
                    // fontu - czyli dokladnie wtedy, kiedy przeliczenie jest potrzebne.
                    this.headerResizeObserver.observe(header.firstElementChild.firstElementChild);
                }
                this.refreshHeaderScrolling();
            },
            stopHeaderScrolling() {
                for (const animation of this.headerAnimations) {
                    animation.cancel();
                }
                this.headerAnimations = [];
            },
            async refreshHeaderScrolling() {
                // Metoda czeka na $nextTick, a wybudza ja ResizeObserver, wiec dwa przebiegi
                // moga sie zazebic. Bez tego znacznika starszy przebieg dopisalby swoja
                // animacje do listy juz wyczyszczonej przez nowszy - i zostalaby na zawsze.
                const token = ++this.headerScrollToken;
                this.stopHeaderScrolling();
                for (const { header, key } of this.headerTargets()) {
                    if (!header) {
                        continue;
                    }

                    const track = header.firstElementChild;
                    const copy = track.firstElementChild;
                    // clientWidth zawiera padding, ktory robi miejsce na skosne sciecie -
                    // tekst jezdzi w polu tresci, wiec o nie trzeba pytac, inaczej ogon
                    // napisu zatrzymywalby sie pod skosem.
                    const style = getComputedStyle(header);
                    const visible = header.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
                    const width = copy.getBoundingClientRect().width;
                    if (visible <= 0 || width - visible <= 1) {
                        this.headerLoop[key] = false;
                        continue;
                    }

                    this.headerLoop[key] = true;
                    await this.$nextTick();
                    if (token !== this.headerScrollToken) {
                        return;
                    }

                    // Przesuniecie o "szerokosc kopii + odstep" ustawia druga kopie dokladnie
                    // tam, gdzie startowala pierwsza - szew petli jest niewidoczny. Stala
                    // predkosc 35 px/s, bez pauz: napis jedzie w lewo i nigdy nie wraca.
                    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
                    const step = width + gap;
                    this.headerAnimations.push(track.animate([
                        { transform: 'translateX(0)' },
                        { transform: `translateX(-${step}px)` }
                    ], { duration: step / 35 * 1000, iterations: Infinity, easing: 'linear' }));
                }
            },
            /**
             * SPA laduje tylko Inter, a stylistyka nakladki stoi na Open Sans - bez tego
             * przegladarka spada na Arial, w ktorym font-weight 100 nie istnieje i cala
             * typografia paska mowcy sie rozjezdza. Ladujemy font tylko dla tego widoku,
             * zeby nie obciazac nim reszty aplikacji.
             */
            ensureOverlayFont() {
                const id = "overlay-open-sans";

                if (document.getElementById(id) !== null)
                    return;

                const link = document.createElement("link");
                link.id = id;
                link.rel = "stylesheet";
                link.href = "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap";
                document.head.appendChild(link);
            },

            /* ---------- cykl zycia posiedzenia ---------- */

            async loadSession() {
                try {
                    const response = await PublicService.getOverlaySession(this.code, this.$i18n.locale);

                    if (response.status !== 200 || response.data === null || response.data.isLive !== true) {
                        this.clientName = response.data === null || response.data === undefined ? "" : (response.data.clientName || "");
                        this.resetSessionState();
                        return;
                    }

                    this.sessionId = response.data.sessionId;
                    this.hydrate(response.data.data);

                    await this.joinSession(this.sessionId);
                }
                catch (e) {
                    console.log(e);
                    this.resetSessionState();
                }
            },

            /**
             * Wejscie do grupy sesji. Zwraca sukces zamiast rzucac, zeby wolajacy mogl
             * zostawic joinedSessionId na 0 i ponowic przy kolejnym ticku.
             */
            async joinSession(sessionId) {
                if (!(sessionId > 0)) {
                    return false;
                }

                try {
                    const joined = await esesjaInteractivePublicService.ensureConnectedAndJoined(sessionId.toString());
                    if (!joined) {
                        this.joinedSessionId = 0;
                        return false;
                    }

                    this.joinedSessionId = sessionId;
                    return true;
                }
                catch (e) {
                    console.log(e);
                    this.joinedSessionId = 0;
                    return false;
                }
            },

            /**
             * Staly adres nakladki obsluguje kolejne posiedzenia - gdy klient uruchomi nastepne,
             * przelaczamy grupe SignalR bez przeladowania wejscia w vMixie.
             */
            async pollForSessionChange(forceHydrate = false) {
                try {
                    const response = await PublicService.getOverlaySession(this.code, this.$i18n.locale);

                    if (response.status !== 200 || response.data === null || response.data === undefined) {
                        return;
                    }

                    const nextSessionId = response.data.isLive === true ? response.data.sessionId : 0;

                    if (nextSessionId !== this.sessionId) {
                        if (this.joinedSessionId > 0) {
                            try {
                                await esesjaInteractivePublicService.leaveRoom(this.joinedSessionId.toString());
                            }
                            catch {
                                // rozlaczony hub - joinSession ponizej i tak odbuduje subskrypcje
                            }
                        }

                        this.resetSessionState();
                        this.sessionId = nextSessionId;
                        this.clientName = response.data.clientName || "";

                        if (nextSessionId > 0) {
                            this.hydrate(response.data.data);
                        }
                    }
                    else if (nextSessionId > 0 &&
                        (forceHydrate || this.joinedSessionId !== this.sessionId ||
                            !esesjaInteractivePublicService.connectionComputedState)) {
                        this.hydrate(response.data.data);
                    }

                    // Domkniecie stanu: jesli sesja trwa, a nie siedzimy w jej grupie
                    // (pierwsze wejscie, nieudany join, zerwany hub) - ponawiamy.
                    if (this.sessionId > 0 &&
                        (this.joinedSessionId !== this.sessionId || !esesjaInteractivePublicService.connectionComputedState)) {
                        await this.joinSession(this.sessionId);
                    }
                }
                catch (e) {
                    console.log(e);
                }
            },

            /** Stan poczatkowy z jednego strzalu - ten sam payload co widok wizualizacji */
            hydrate(data) {
                if (data === null || data === undefined) {
                    return;
                }

                this.clientName = data.client || "";
                this.sessionName = this.buildSessionName(data.session);
                this.agendaItems = data.session === null || data.session === undefined ? [] : (data.session.agendaItems || []);
                this.logo = data.logo === null || data.logo === undefined ? "" : (data.logo.image || "");

                if (data.clientSettings !== null && data.clientSettings !== undefined) {
                    this.$store.state.settings.runtime = data.clientSettings;
                }

                if (data.placeholder !== null && data.placeholder !== undefined) {
                    this.ChangePlaceholderStatus({ placeholder: data.placeholder, isActive: true });
                }
                else {
                    this.placeholderData = {};
                    this.$store.commit("setPublicPlaceholderViewModalStatus", false);
                }

                // Samodzielny licznik jest przesyłany wyłącznie zdarzeniami SignalR.
                // Snapshot dyskusji nie zawiera jego stanu i nie może go kasować.
                if (!this.isDummySpeechActive) {
                    const currentSpeech = data.discussion === null || data.discussion === undefined ? null : data.discussion.currentSpeech;
                    if (currentSpeech !== null && currentSpeech !== undefined && currentSpeech.userId > 0) {
                        this.UserStartSpeech(currentSpeech);
                    }
                    else {
                        this.UserEndSpeech();
                    }
                }

                if (data.sesbreak !== null && data.sesbreak !== undefined) {
                    this.SessionBreakStatusChange(data.sesbreak);
                }
                else {
                    this.endBreak();
                }

                if (data.activePoint !== null && data.activePoint > 0) {
                    this.setActivePoint(data.activePoint);
                }
                else {
                    this.activePointName = "";
                }
            },

            resetSessionState() {
                this.sessionId = 0;
                this.joinedSessionId = 0;
                this.sessionName = "";
                this.agendaItems = [];
                this.activePointName = "";
                this.clearSpeech();
                this.showVotingStartedInfo = false;
                this.showQuorumResultModal = false;
                this.quorumresult = [];
                this.quorumIsRunning = false;
                this.showAttachmentViewer = false;
                this.$store.commit("setPublicPlaceholderViewModalStatus", false);
                this.$store.commit("setInteractiveVotingModalStatus", false);
                this.CloseVotingResultModal();
                this.endBreak();
            },

            buildSessionName(session) {
                if (session === null || session === undefined)
                    return "";

                const name = getPublicSessionName(session, 999999999999);
                const date = session.meeting_date ? moment(session.meeting_date).format("L") : "";

                return date ? `${name} ${this.$t('com.file.overlay.on-day')} ${date}` : name;
            },

            /* ---------- SignalR ---------- */

            registerInteractiveEvents() {
                const on = (action, handler) => esesjaInteractivePublicService.events.on(action.name, handler);

                on(signalrSocketAction.ActiveAgendaPointChange, this.ActiveAgendaPointChange);
                on(signalrSocketAction.CurrentAgendaItems, this.CurrentAgendaItems);
                on(signalrSocketAction.SessionBreakStatusChange, this.SessionBreakStatusChange);
                on(signalrSocketAction.AddTimeToSpeakerForPublic, this.AddTimeToSpeakerForPublic);
                on(signalrSocketAction.UserStartSpeech, this.UserStartSpeech);
                on(signalrSocketAction.UserEndSpeech, this.UserEndSpeech);
                on(signalrSocketAction.StartDummySpeech, this.StartDummySpeech);
                on(signalrSocketAction.EndDummySpeech, this.EndDummySpeech);
                on(signalrSocketAction.QuorumStarted, this.QuorumStarted);
                on(signalrSocketAction.QuorumEnded, this.QuorumEnded);
                on(signalrSocketAction.QuorumResultsChanged, this.QuorumResultsChanged);
                on(signalrSocketAction.QuorumSummaryReults, this.QuorumSummaryReults);
                on(signalrSocketAction.CloseResultCheckQuorumModal, this.CloseResultCheckQuorumModal);
                on(signalrSocketAction.VotingStarted, this.VotingStarted);
                on(signalrSocketAction.VotingEnded, this.VotingEnded);
                on(signalrSocketAction.OpenInteractiveVotingPublic, this.OpenInteractiveVotingPublic);
                on(signalrSocketAction.VoteResultSummary, this.VoteResultSummary);
                on(signalrSocketAction.CloseVotingResultModal, this.CloseVotingResultModal);
                on(signalrSocketAction.ShowHideVotingResultsLive, this.ShowHideVotingResultsLive);
                on(signalrSocketAction.ChangePlaceholderStatus, this.ChangePlaceholderStatus);
                on(signalrSocketAction.OpenAttachment, this.OpenAttachment);
                on(signalrSocketAction.ChangeAttachmentName, this.ChangeAttachmentPage);
                on(signalrSocketAction.ScroolAttachmentName, this.ScroolAttachmentPage);
                on(signalrSocketAction.CloseAttachment, this.CloseAttachment);
                on(signalrSocketAction.CurrentClientSettings, this.SetCurrentClientSettings);
                on(signalrSocketAction.SignalRReconnected, this.SignalRReconnected);
            },

            unregisterInteractiveEvents() {
                const off = (action, handler) => esesjaInteractivePublicService.events.removeListener(action.name, handler);

                off(signalrSocketAction.ActiveAgendaPointChange, this.ActiveAgendaPointChange);
                off(signalrSocketAction.CurrentAgendaItems, this.CurrentAgendaItems);
                off(signalrSocketAction.SessionBreakStatusChange, this.SessionBreakStatusChange);
                off(signalrSocketAction.AddTimeToSpeakerForPublic, this.AddTimeToSpeakerForPublic);
                off(signalrSocketAction.UserStartSpeech, this.UserStartSpeech);
                off(signalrSocketAction.UserEndSpeech, this.UserEndSpeech);
                off(signalrSocketAction.StartDummySpeech, this.StartDummySpeech);
                off(signalrSocketAction.EndDummySpeech, this.EndDummySpeech);
                off(signalrSocketAction.QuorumStarted, this.QuorumStarted);
                off(signalrSocketAction.QuorumEnded, this.QuorumEnded);
                off(signalrSocketAction.QuorumResultsChanged, this.QuorumResultsChanged);
                off(signalrSocketAction.QuorumSummaryReults, this.QuorumSummaryReults);
                off(signalrSocketAction.CloseResultCheckQuorumModal, this.CloseResultCheckQuorumModal);
                off(signalrSocketAction.VotingStarted, this.VotingStarted);
                off(signalrSocketAction.VotingEnded, this.VotingEnded);
                off(signalrSocketAction.OpenInteractiveVotingPublic, this.OpenInteractiveVotingPublic);
                off(signalrSocketAction.VoteResultSummary, this.VoteResultSummary);
                off(signalrSocketAction.CloseVotingResultModal, this.CloseVotingResultModal);
                off(signalrSocketAction.ShowHideVotingResultsLive, this.ShowHideVotingResultsLive);
                off(signalrSocketAction.ChangePlaceholderStatus, this.ChangePlaceholderStatus);
                off(signalrSocketAction.OpenAttachment, this.OpenAttachment);
                off(signalrSocketAction.ChangeAttachmentName, this.ChangeAttachmentPage);
                off(signalrSocketAction.ScroolAttachmentName, this.ScroolAttachmentPage);
                off(signalrSocketAction.CloseAttachment, this.CloseAttachment);
                off(signalrSocketAction.CurrentClientSettings, this.SetCurrentClientSettings);
                off(signalrSocketAction.SignalRReconnected, this.SignalRReconnected);
            },

            SignalRReconnected() {
                this.joinedSessionId = 0;
                this.recoverConnection().catch((e) => {
                    console.log(e);
                });
            },

            handleConnectionResume() {
                if (document.hidden) {
                    return;
                }

                this.recoverConnection().catch((e) => {
                    console.log(e);
                });
            },

            recoverConnection() {
                if (this.recoveryPromise !== null) {
                    return this.recoveryPromise;
                }

                this.recoveryPromise = this.recoverConnectionCore()
                    .finally(() => {
                        this.recoveryPromise = null;
                    });

                return this.recoveryPromise;
            },

            async recoverConnectionCore() {
                if (this.sessionId > 0) {
                    this.joinedSessionId = 0;
                    await this.joinSession(this.sessionId);
                }

                // Po uspieniu zdarzenia SignalR nie sa odtwarzane. Ponowne pobranie
                // snapshotu uzupelnia stan, ktory mogl zmienic sie podczas rozlaczenia.
                await this.pollForSessionChange(true);
                await this.syncServerTime();
            },

            /* ---------- punkt porzadku ---------- */

            ActiveAgendaPointChange(data) {
                if (data === null || data === undefined || data.status !== 0 || !(data.point > 0)) {
                    this.activePointName = "";
                    return;
                }

                this.setActivePoint(data.point);
            },

            setActivePoint(pointId) {
                this.activePointName = this.findPointName(this.agendaItems, pointId);
            },

            findPointName(items, pointId) {
                if (items === null || items === undefined)
                    return "";

                for (const item of items) {
                    if (item.id === pointId)
                        return item.name || item.title || "";

                    const found = this.findPointName(item.children, pointId);
                    if (found)
                        return found;
                }

                return "";
            },

            async CurrentAgendaItems() {
                try {
                    const response = await PublicService.getOverlaySession(this.code, this.$i18n.locale);

                    if (response.status !== 200 || response.data === null || response.data.isLive !== true)
                        return;

                    const payload = response.data.data;
                    this.agendaItems = payload === null || payload.session === null || payload.session === undefined ? [] : (payload.session.agendaItems || []);

                    const activePoint = payload === null ? 0 : payload.activePoint;
                    this.activePointName = activePoint > 0 ? this.findPointName(this.agendaItems, activePoint) : "";
                }
                catch (e) {
                    console.log(e);
                }
            },

            /* ---------- mowca ---------- */

            async UserStartSpeech(data) {
                if (data !== null && data !== undefined && data.userId > 0) {
                    this.isDummySpeechActive = false;
                    this.speeker = data;
                    this.showSpeeker = true;
                    await this.startSpeechTimer();
                }
            },

            /**
             * Licznik wypowiedzi celowo nie korzysta z syncServerTime()/now() tego widoku,
             * tylko z helpera - wizualizacja liczy ta sama metoda, a oba ekrany tej samej
             * sesji musza pokazywac te sama liczbe.
             */
            async startSpeechTimer() {
                this.speechReference = await captureServerReference();
                this.refreshSpeechTime();
            },

            refreshSpeechTime() {
                if (!this.showSpeeker) {
                    this.speechTimeLabel = "00:00:00";
                    this.isSpeechOvertime = false;
                    return;
                }

                const time = calculateSpeechTime(this.speeker, this.speechReference);
                this.speechTimeLabel = time.label;
                this.isSpeechOvertime = time.isOvertime;
            },

            async StartDummySpeech(data) {
                this.isDummySpeechActive = true;
                this.speeker = {
                    ...this.speeker,
                    name: this.speeker && this.speeker.name ? this.speeker.name : this.$t('com.file.discussion-list-modal.discussion'),
                    isCountdown: true,
                    seconds: data.duration,
                    startTime: data.startTimestamp
                };
                this.showSpeeker = true;
                await this.startSpeechTimer();
            },

            AddTimeToSpeakerForPublic(data) {
                if (data !== null && data !== undefined && this.showSpeeker && this.speeker !== null) {
                    if (this.speeker.userId === data.userId && this.speeker.discussionId === data.discussionId) {
                        this.speeker.seconds = data.time;
                    }
                }
            },

            UserEndSpeech() {
                if (this.isDummySpeechActive && !(this.speeker.userId > 0)) {
                    return;
                }

                this.clearSpeech();
            },

            EndDummySpeech() {
                if (this.isDummySpeechActive) {
                    this.clearSpeech();
                }
            },

            clearSpeech() {
                this.showSpeeker = false;
                this.isDummySpeechActive = false;
                this.speeker = {};
                this.speechReference = emptyServerReference();
                this.speechTimeLabel = "00:00:00";
                this.isSpeechOvertime = false;
            },

            /* ---------- przerwa + vMix ---------- */

            SessionBreakStatusChange(data) {
                if (data !== null && data !== undefined && data.state === 0) {
                    this.startBreak(data);
                }
                else {
                    this.endBreak();
                }
            },

            startBreak(data) {
                const start = new Date(Date.parse(data.startTime));
                this.breakEndTime = new Date(start.getTime() + (parseInt(data.duration) * 60000));
                this.breakEndLabel = moment(this.breakEndTime).format("LT");
                this.showBreak = true;
                this.refreshBreakCountdown();
                overlayVmix.masterAudioOff();
            },

            endBreak() {
                if (!this.showBreak)
                    return;

                this.showBreak = false;
                this.breakEndTime = null;
                this.isBreakOvertime = false;
                this.breakCountdown = "00:00:00";
                overlayVmix.masterAudioOn();
            },

            refreshBreakCountdown() {
                if (this.breakEndTime === null)
                    return;

                const now = this.now();
                this.isBreakOvertime = (this.breakEndTime - now) < 0;

                const diff = timeUnitsBetween(now, this.breakEndTime);
                this.breakCountdown = `${getLeadZero(diff.hours + 24 * diff.days)}:${getLeadZero(diff.minutes)}:${getLeadZero(diff.seconds)}`;
            },

            /* ---------- placeholder ---------- */

            ChangePlaceholderStatus(data) {
                this.placeholderData = data.placeholder || {};
                this.$store.commit("setPublicPlaceholderViewModalStatus", data.isActive);
            },

            /* ---------- kworum ---------- */

            QuorumStarted() {
                this.showQuorumResultModal = true;
                this.quorumIsRunning = true;
            },

            QuorumResultsChanged(data) {
                if (this.quorumIsRunning === true)
                    this.quorumresult = data;
            },

            QuorumSummaryReults(data) {
                this.quorumresult = data;
                this.showQuorumResultModal = true;
            },

            QuorumEnded() {
                this.showQuorumResultModal = false;
                this.quorumIsRunning = false;
            },

            CloseResultCheckQuorumModal() {
                this.quorumresult = [];
                this.showQuorumResultModal = false;
            },

            /* ---------- glosowanie ---------- */

            VotingStarted(data) {
                this.votingStartedName = data === null || data === undefined ? "" : (data.name || "");
                this.showVotingStartedInfo = true;

                clearTimeout(this.votingInfoTimer);
                this.votingInfoTimer = setTimeout(() => { this.showVotingStartedInfo = false; }, VOTING_INFO_VISIBLE_MS);
            },

            async OpenInteractiveVotingPublic(token) {
                try {
                    this.CloseVotingResultModal();

                    const response = await PublicService.getDataForVotingPublic(token, this.$i18n.locale);

                    if (response.status === 200) {
                        this.dataForVoting = response.data.basicData;
                        this.votingPossibleAnswers = response.data.options
                            .filter(x => x.option !== this.$t('com.file.interactive-voting-public-modal.vote-absent-prular') &&
                                x.option !== this.$t('com.file.interactive-voting-public-modal.vote-absent-singular') &&
                                x.option !== this.$t('com.file.interactive-voting-public-modal.vote-lack'));

                        this.$store.commit('setInteractiveVotingModalStatus', true);
                    }
                }
                catch (e) {
                    console.log(e);
                }
            },

            VotingEnded() {
                this.showVotingStartedInfo = false;
                this.$store.commit('setInteractiveVotingModalStatus', false);
                this.dataForVoting = {};
                this.votingPossibleAnswers = [];
            },

            ShowHideVotingResultsLive(data) {
                this.hiddenResults = !data;
            },

            VoteResultSummary(data) {
                this.showVotingStartedInfo = false;

                const summary = data.s;
                if (summary === null || summary === undefined)
                    return;

                const chartData = {
                    labels: [],
                    datasets: [{ data: [], backgroundColor: [] }]
                };

                const values = [];
                for (let i = 0; i < summary.options.length; i++) {
                    chartData.labels.push(summary.options[i].option);
                    values.push(summary.options[i].count);
                    chartData.datasets[0].data = values;
                    chartData.datasets[0].backgroundColor.push(this.formatAnswersColor(summary.options[i].option));
                }

                this.$store.commit("setCanCloseStatus", false);
                this.$store.commit("setFromEndVotingCallStatus", false);
                this.$store.commit("setIsPublicViewCallStatus", true);
                this.$store.commit("setVotingChartData", chartData);
                this.$store.commit("setVotingInternalBasicData", data.u);
                this.$store.commit("setVotingPossibleAnswersData", summary);
                this.$store.commit("setIsShowInteractiveVotingResultsModalStatus", true);
            },

            formatAnswersColor(result) {
                if (result === null || result === undefined || result.length === 0)
                    return '#7cd1eb';

                switch (result) {
                    case this.$t('com.file.interactive-voting-public-modal.vote-for'):
                    case this.$t('com.file.interactive-voting-public-modal.vote-yes'):
                        return '#79e563';
                    case this.$t('com.file.interactive-voting-public-modal.vote-against'):
                    case this.$t('com.file.interactive-voting-public-modal.vote-no'):
                        return '#e40030';
                    case this.$t('com.file.interactive-voting-public-modal.vote-abstain'):
                    case this.$t('com.file.interactive-voting-public-modal.vote-dont-know'):
                        return '#ffce56';
                    case this.$t('com.file.interactive-voting-public-modal.vote-lack'):
                        return '#c0c0c0';
                    case this.$t('com.file.interactive-voting-public-modal.vote-absent-prular'):
                    case this.$t('com.file.interactive-voting-public-modal.vote-absent-singular'):
                        return '#000';
                    case this.$t('com.file.interactive-voting-public-modal.vote-excluded'):
                    case this.$t('com.file.interactive-voting-public-modal.vote-excluded2'):
                        return '#363532';
                    default:
                        return '#7cd1eb';
                }
            },

            CloseVotingResultModal() {
                this.$store.commit("setIsShowInteractiveVotingResultsModalStatus", false);
                this.$store.commit("setVotingChartData", { labels: [], datasets: [{ data: [] }] });
            },

            /* ---------- zalaczniki PDF ---------- */

            async OpenAttachment(data) {
                try {
                    const response = await PublicService.getFile(data.ssoToken);

                    if (response.status === 200) {
                        this.attachmentData.fileData = response;
                        this.attachmentData.page = data.page || 1;

                        /*
                         * 0 znaczy "admin nie podal powiekszenia" - modal dopasuje wtedy
                         * strone do kadru. Przypisujemy bezwarunkowo, bo inaczej zostawalaby
                         * tu skala z poprzedniego zalacznika i nowy otwieralby sie w cudzym
                         * powiekszeniu.
                         */
                        this.attachmentData.scale = data.scale > 0 ? data.scale : 0;

                        this.showAttachmentViewer = true;
                    }
                }
                catch (e) {
                    console.log(e);
                }
            },

            ChangeAttachmentPage(data) {
                this.attachmentData.page = data.page;
                this.attachmentData.scale = data.scale;
            },

            ScroolAttachmentPage(data) {
                this.attachmentData.scrool = data.percent;
            },

            CloseAttachment() {
                this.showAttachmentViewer = false;
                this.attachmentData.fileData = {};
                this.attachmentData.page = 1;
                // 0, nie 100 - zeby kolejne otwarcie bez podanej skali zostalo rozpoznane
                // jako "dopasuj do kadru", a nie jako jawne zyczenie stu procent.
                this.attachmentData.scale = 0;
            },

            SetCurrentClientSettings(settings) {
                this.$store.state.settings.runtime = settings;
            },

            /* ---------- zegar i data (czas serwera) ---------- */

            /**
             * Data liczona z czasu serwera, wiec przeskakuje o polnocy sama - stara nakladka
             * brala ja raz, przy ladowaniu zrodla do vMixa, i po nocy pokazywala wczorajsza.
             * Etykieta przeliczana tylko przy zmianie doby, nie co sekunde.
             */
            refreshDateLabel(now) {
                const dayKey = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}`;

                if (dayKey === this.currentDayKey)
                    return;

                this.currentDayKey = dayKey;
                this.currentDateLabel = formatDateToDisplay(now, "weekdayDate");
            },


            /**
             * Czas serwera skorygowany o polowe czasu przelotu zadania - zegar na wizji
             * nie moze zalezec od ustawien maszyny, na ktorej stoi vMix.
             * Przy bledzie zostaje ostatni znany offset (na starcie 0, czyli czas lokalny),
             * bo pusty zegar w transmisji jest gorszy niz zegar odchylony o sekundy.
             */
            async syncServerTime() {
                try {
                    const sentAt = Date.now();
                    const response = await toolsService.getServerTime();
                    const receivedAt = Date.now();

                    if (response.status !== 200 || !response.data)
                        return;

                    const serverMs = new Date(response.data).getTime();
                    if (isNaN(serverMs))
                        return;

                    this.serverOffsetMs = serverMs - (sentAt + (receivedAt - sentAt) / 2);
                }
                catch (e) {
                    console.log(e);
                }
            },

            /** Jedyne zrodlo "teraz" w nakladce - zegar i odliczanie przerwy licza z niego. */
            now() {
                return new Date(Date.now() + this.serverOffsetMs);
            },

            tick() {
                const now = this.now();
                // stara nakladka padowala tylko minuty (h + ":" + checkTime(m)) - zostawiamy "9:36"
                this.clockHours = `${now.getHours()}`;
                this.clockMinutes = getLeadZero(now.getMinutes());
                this.refreshDateLabel(now);
                this.refreshBreakCountdown();
                this.refreshSpeechTime();
            }
        }
    };
</script>

<style lang="scss">
    @use "@/assets/scss/overlay.scss";
</style>
